import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { ClassCategoryEnum } from 'src/app/models/enums/ClassCategoryEnum';
import { ClassAndEndpoint } from 'src/app/models/classandendpoint.model';
import { ServiceClass } from 'src/app/models/serviceClass.model';

@Component({
  selector: 'app-wagon-class-creation',
  templateUrl: './wagon-class-creation.component.html',
  styleUrls: ['./wagon-class-creation.component.scss']
})
export class WagonClassCreationComponent implements OnInit {
  classNumber: number;
  classAreas: Array<Array<ClassAndEndpoint>>;
  @Input() maxValue: number;
  @Input() yLength: number;
  @Input() floorCount: number;
  @Input() serviceClasses: ServiceClass[];
  @Output() classes: EventEmitter<Array<Array<ClassAndEndpoint>>> = new EventEmitter<Array<Array<ClassAndEndpoint>>>();

  wagonClass = {
    classSelectionTitel: 'Select the number of classes in the carriage',
    buttonSaveChanges: 'Save Class Configuration'
  }

  constructor() {
    this.classAreas = new Array();
  }

  ngOnInit() {
    for (let index = 0; index < this.floorCount; index++) {
      this.classAreas.push(new Array);
    }
  }

  onSelectionChange(evt: Event) {
    this.classNumber = Number((<MatRadioChange><unknown>evt).value);
    let defaultValue = new ClassAndEndpoint();
    defaultValue.endpoint = this.maxValue;
    defaultValue.class = ClassCategoryEnum.Economy;
    let defaultValue2 = new ClassAndEndpoint();
    defaultValue2.endpoint = this.maxValue;
    defaultValue2.class = ClassCategoryEnum.Economy;
    
    if (this.classNumber == 1 && this.floorCount == 1 || this.classNumber == 2 && this.floorCount == 1) {
      this.classAreas[0] = new Array();
      this.classAreas[0].push(defaultValue);
    }
    else {
      this.classAreas[0] = new Array();
      this.classAreas[1] = new Array();
      this.classAreas[0].push(defaultValue);
      this.classAreas[1].push(defaultValue2);
    }
    
    this.resetParentValue();
  }

  addClassCategory(floorI: number) {
    var cae = new ClassAndEndpoint();
    cae.endpoint = this.maxValue;
    this.classAreas[floorI].push(cae);
  }

  removeClassCategory(floorIndex) {
    this.classAreas[floorIndex].pop();
  }

  resetParentValue(){
    // when changing between single and multiple classes emit null to reset any value which might have been set inbetween in the parent control
    // also emit null when a class selection or input value changes so the user needs to explicitly call save again
    this.classes.emit(null);
  }

  save() {
    this.classes.emit(this.classAreas);
  }

  getAddButtonDisabledState(floorIndex: number, pos: number): boolean {
    let disabled = true;

    let minValue = pos > 0 ? this.classAreas[floorIndex][pos - 1].endpoint + 1 : 0;

    let maxValueValid = this.classAreas[floorIndex][pos].endpoint < this.maxValue;

    let minValueValid = this.classAreas[floorIndex][pos].endpoint >= minValue;

    let isLastEntry = this.classAreas[floorIndex][pos + 1] == undefined;

    disabled = !(maxValueValid && minValueValid && isLastEntry);

    return disabled;
  }
  getremoveButtonDisabledState(floorIndex: number, pos: number): boolean {
    let disabled = true;

    let isLastEntry = this.classAreas[floorIndex].length == pos + 1;

    let isNotFirstEntry = pos > 0;

    disabled = !(isLastEntry && isNotFirstEntry);

    return disabled;
  }

  getSaveButtonDisabledState() {
    let disabled = false;

    let arrayNotEmpty = this.classAreas.length > 0;

    let inputValid = true;

    for (let floorIndex = 0; floorIndex < this.classAreas.length; floorIndex++) {
      if (inputValid) {
        let totalWidth = 0;
        for (let index = 0; index < this.classAreas[floorIndex].length; index++) {

          let endOfArea = this.classAreas[floorIndex][index].endpoint;
          var minimum = index > 0 ? this.classAreas[floorIndex][index - 1].endpoint : 0;

          let width = (endOfArea - minimum);
          if (width <= 0) {
            inputValid = false;
            break;
          } else {
            totalWidth += width;
          }

          if (minimum > endOfArea || endOfArea > this.maxValue || this.classAreas[floorIndex][index].class == undefined) {
            inputValid = false;
            break;
          }
        }

        if (totalWidth != this.maxValue) {
          inputValid = false;
          break;
        }
      }
      else {
        break;
      }
    }

    disabled = arrayNotEmpty && inputValid;
    if(!disabled){
      this.classes.emit(null);
    }
    return !disabled;
  }
}